<template>
  <div class="container container-sm login mb-3">
    <Card>
      <template #title>
        <h3>{{ t("AUTHENTICATION") }}</h3>
      </template>

      <template #content>
        <form @submit.prevent="login">
          <div class="row mb-2">
            <div class="col">
              <InputText class="w-100" type="text" name="username" :placeholder="t('SSN')" v-model="creds.username" autofocus @input="(e) => creds.username = (e.target?.value || '').replace(/\s/g, '')"/>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col input-group">
              <InputText class="flex-grow-1" :placeholder="t('PASSWORD')" :type="passwordHidden ? 'text' : 'password'" v-model="creds.password"/>
              <span v-if="creds.password !== ''" class="input-group-text" style="cursor: pointer" @click="toggleShowPassword">
                <i :class="passwordHidden ? 'pi pi-eye-slash' : 'pi pi-eye'"/>
              </span>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col">
              <Button type="submit" :label="t('ENTER')"/>
            </div>
          </div>
        </form>
      </template>
    </Card>
  </div>
</template>

<style scoped>
.login {
  margin-top: 64px;
}
</style>

<script setup>
import {ref} from "vue";
import {injectAxios, injectAuth} from "@/util/inject";
import {useI18n} from "vue-i18n";

const passwordHidden = ref(false);
const axios = injectAxios();
const auth = injectAuth();
const {t} = useI18n();
const creds = ref({
  username: "",
  password: "",
});

function toggleShowPassword() {
  passwordHidden.value = !passwordHidden.value;
}

async function login() {
  try {
    const response = await axios.post('/login/plain', creds.value);
    await auth.login(response.data.token);
  } finally {
    creds.value.password = "";
  }
}
</script>
